import {observer} from 'mobx-react-lite'
import React from 'react'
import {StickerType} from 'yougile-model'
import {StickerMenuDeadline} from '@components/sticker/sticker-menu/sticker-menu-deadline'
import {StickerNumericMenu} from '@components/sticker/sticker-menu/sticker-menu-numeric'
import {StickerMenuRepeat} from '@components/sticker/sticker-menu/sticker-menu-repeat'
import {StickerMenuSprint} from '@components/sticker/sticker-menu/sticker-menu-sprint'
import {StickerStopwatchMenu} from '@components/sticker/sticker-menu/sticker-menu-stopwatch'
import {StickerMenuString} from '@components/sticker/sticker-menu/sticker-menu-string'
import {StickerTextMenu} from '@components/sticker/sticker-menu/sticker-menu-text'
import {StickerMenuTimeTracking} from '@components/sticker/sticker-menu/sticker-menu-time-tracking'
import {StickerMenuTimer} from '@components/sticker/sticker-menu/sticker-menu-timer'
import {StickerMenuUser} from '@components/sticker/sticker-menu/sticker-menu-user'
import {useStickerStore} from '@components/sticker/sticker-store'

const StickerTypesMenu: Record<
  StickerType,
  React.FunctionComponent | undefined
> = {
  text: StickerTextMenu,
  numeric: StickerNumericMenu,
  stopwatch: StickerStopwatchMenu,
  user: StickerMenuUser,
  string: StickerMenuString,
  sprint: StickerMenuSprint,
  deadline: StickerMenuDeadline,
  repeat: StickerMenuRepeat,
  timer: StickerMenuTimer,
  timetracking: StickerMenuTimeTracking
}

export const StickerMenu = observer(() => {
  const [, store] = useStickerStore()
  const {stickerType} = store.stickerData

  const Component = StickerTypesMenu[stickerType]

  return Component ? <Component /> : <></>
})
